import Wrong from '@assets/wrong.svg';
import { Note } from '@components';

// const errorMsg = 'Sorry, you are not authorized to access this page.';

export function ForbiddenPage() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
    >
      <Note
        icon={Wrong}
        style={{ marginBottom: 150 }}
        title="403 Forbidden"
        subTitle="Access Denied"
        hasBackBtn={false}
      >

        <section style={{
          color: '#4B5563',
          textAlign: 'center',
          marginBottom: '24px',
        }}
        >
          {/* <p style={{ marginBottom: '16px' }}>{errorMsg}</p> */}
        </section>
      </Note>
    </div>
  );
}
